import React from 'react';
import { motion } from 'framer-motion';
import { Download, Calendar, User, ArrowRight, Search } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
const articles = [{
  id: 1,
  title: 'Understanding Holistic Wellness: A Guide to Total Health',
  excerpt: 'Explore the connection between physical health and mental well-being in our comprehensive guide to holistic living.',
  date: 'April 5, 2026',
  author: 'Clinical Team',
  category: 'Wellness',
  image: 'https://cdn.magicpatterns.com/uploads/tDpvm1x4bUSX1p1PDqUwmQ/Healthcare_Patients.webp',
  downloadUrl: '#'
}, {
  id: 2,
  title: 'Navigating Trauma: Steps Toward Emotional Restoration',
  excerpt: 'Practical advice and professional insights on overcoming trauma and rebuilding emotional strength.',
  date: 'March 28, 2026',
  author: 'Mental Health Coach',
  category: 'Mental Health',
  image: 'https://cdn.magicpatterns.com/uploads/e4LVpLJpYC1KKKciqBgn3q/Mental_Health_Coaching_Services.webp',
  downloadUrl: '#'
}, {
  id: 3,
  title: 'The Importance of Preventive Health Risk Assessments',
  excerpt: 'Why regular HRAs are the cornerstone of a proactive healthcare strategy for you and your family.',
  date: 'March 15, 2026',
  author: 'Nurse Practitioner',
  category: 'Prevention',
  image: 'https://cdn.magicpatterns.com/uploads/41mmTjpjeUo4EuVuLHcpnf/Health_Risk_Assessments_(HRAs).jpg',
  downloadUrl: '#'
}];
export function Blog() {
  return <main className="pt-32 pb-16 bg-medical-cream/30" data-id="element-143">
      <section className="max-w-7xl mx-auto px-6" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="text-medical-red font-display text-xs uppercase tracking-[0.3em] mb-4 block" data-id="element-146">
            Insights & Resources
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-heading font-extrabold text-medical-blue mb-8" data-id="element-147">
            Our <span className="text-medical-red italic" data-id="element-148">Blog</span>
          </motion.h1>
          <div className="max-w-2xl mx-auto relative" data-id="element-149">
            <input type="text" placeholder="Search articles..." className="w-full bg-white border border-medical-gray/50 rounded-full px-8 py-4 focus:outline-none focus:border-medical-red shadow-sm font-body" data-id="element-150" />
            <Search className="absolute right-6 top-1/2 -translate-y-1/2 text-medical-blue/40" size={20} data-id="element-151" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-152">
          {articles.map((article, i) => <motion.article key={article.id} {...fadeInUp} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-[32px] overflow-hidden shadow-xl border border-medical-gray/20 flex flex-col" data-id="element-153">
              <div className="aspect-[16/10] overflow-hidden relative" data-id="element-154">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-155" />
                <span className="absolute top-4 left-4 bg-medical-red text-white text-[10px] font-display uppercase tracking-widest px-4 py-1.5 rounded-full" data-id="element-156">
                  {article.category}
                </span>
              </div>
              <div className="p-8 flex-1 flex flex-col" data-id="element-157">
                <div className="flex items-center gap-4 text-xs text-medical-blue/50 font-display mb-4" data-id="element-158">
                  <span className="flex items-center gap-1.5" data-id="element-159">
                    <Calendar size={14} data-id="element-160" /> {article.date}
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-161">
                    <User size={14} data-id="element-162" /> {article.author}
                  </span>
                </div>
                <h3 className="text-2xl font-heading text-medical-blue mb-4 leading-tight" data-id="element-163">
                  {article.title}
                </h3>
                <p className="text-medical-blue/60 font-body text-lg mb-8 line-clamp-3" data-id="element-164">
                  {article.excerpt}
                </p>
                <div className="mt-auto flex items-center justify-between pt-6 border-t border-medical-gray/30" data-id="element-165">
                  <button className="text-medical-red font-display text-xs font-bold uppercase tracking-widest flex items-center gap-2 hover:text-medical-blue transition-colors" data-id="element-166">
                    Read More <ArrowRight size={14} data-id="element-167" />
                  </button>
                  <a href={article.downloadUrl} className="p-2 bg-medical-cream text-medical-blue rounded-lg hover:bg-medical-red hover:text-white transition-all" title="Download Article" data-id="element-168">
                    <Download size={18} data-id="element-169" />
                  </a>
                </div>
              </div>
            </motion.article>)}
        </div>
      </section>
    </main>;
}